import { useEffect, useState } from 'react'
import { gql } from '@apollo/client'
import { apolloClient } from 'lib/apollo'
import { MasterData, Query } from 'types/graphql'

const QUERY_PACKAGE_SIZES = gql`
  query {
    getMasterData(name: PACKAGE_SIZE) {
      code
      displayName
    }
  }
`

const useQueryPackageSizes = (): MasterData[] => {
  const [packageSizes, setPackageSizes] = useState<MasterData[]>([])
  useEffect(() => {
    ;(async () => {
      const { error, data } = await apolloClient.query<Query>({ query: QUERY_PACKAGE_SIZES })
      if (error) {
        console.error(error)
        return
      }
      if (data?.getMasterData) {
        setPackageSizes([...data.getMasterData])
      }
    })()
  }, [])
  return packageSizes
}

export default useQueryPackageSizes
